import { render, staticRenderFns } from "./ProductsRecord.vue?vue&type=template&id=58cf5b32"
import script from "./ProductsRecord.vue?vue&type=script&lang=js"
export * from "./ProductsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports